import type React from "react";
import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router";

const PromoCode: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const promoCode = searchParams.get("code");

  useEffect(() => {
    // Redirect to main page with promo parameter
    if (promoCode) {
      navigate(`/?promo=${encodeURIComponent(promoCode)}`);
    } else {
      // If no promo code, redirect to main page
      navigate("/");
    }
  }, [promoCode, navigate]);

  // Show loading while redirecting
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-0 mx-auto" />
        <p className="mt-4 text-sm text-text-secondary">Redirecting...</p>
      </div>
    </div>
  );
};

export default PromoCode;
